import TransferHeader from './TransferHeader';
import TextEntity from './TextEntity';
import NormalButton from './NormalButton';
import { useNavigate } from 'react-router-dom';

export default function TransferFinalForm({ onCancel, setProgress, amount, data }) {
  const navigate = useNavigate();
  return (
    <>
      <TransferHeader headerTitle="Comprobante de transferencia" goBack={() => setProgress(2)} />

      <div className="space-y-4">
        <div className="w-full bg-[#FDFDFD] px-4 py-2 border border-[#E6EBF7] rounded-[10px]">
          <p className="inline text-sm text-[#092F7B] font-semibold leading-[22px]">Transferiste</p>
          <div className="h-9 flex items-center">
            <p className="text-xl text-[#181D27] font-semibold text-center py-1">
              {`${parseFloat(amount).toFixed(2)} USD`}
            </p>
          </div>
        </div>

        <div className="space-y-4 px-4">
          {data.map((item, idx) => (
            <TextEntity key={idx} title={item.title} content={item.content} />
          ))}
        </div>
      </div>

      <span className="float-right">
        <div className="space-x-2.5">
          <NormalButton
            customClass="text-[#FDFDFD] bg-[#092F7B]"
            text="Confirmar"
            onClick={() => navigate('/dashboard/history')}
          />
        </div>
      </span>
    </>
  );
}
